import {h} from 'preact';
import {useContext, useState, createContext} from "preact/compat";

// Creates a new empty context
const MemoContext = createContext(null);

// This is the main memo context in which we will store the cached page data
export const MemoContextProvider = props => {
    // Destructured props
    const {children} = props;

    // Home page data
    const [_memoizedHomePageData, _setMemoizedHomePageData] = useState({});
    // Product page data
    const [_memoizedProductPageData, _setMemoizedProductPageData] = useState({});

    // Order success data
    const [_memoizedOrderSuccessData, _setMemoizedOrderSuccessData] = useState({});
    // Order failure data
    const [_memoizedOrderFailureData, _setMemoizedOrderFailureData] = useState({});

    // The data that will be soon returned by the context
    const data = {
        _memoizedHomePageData,
        _setMemoizedHomePageData,
        _memoizedProductPageData,
        _setMemoizedProductPageData,

        _memoizedOrderSuccessData,
        _setMemoizedOrderSuccessData,
        _memoizedOrderFailureData,
        _setMemoizedOrderFailureData
    };

    return (
        <MemoContext.Provider value={data}>
            {children}
        </MemoContext.Provider>
    )
}

// Hook to provide a simple context accessibility
const useMemoContext = () => useContext(MemoContext);
export default useMemoContext;
